import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This sound example demonstrates the need for binaural recordings when evaluating product sounds. Listen to both recordings and try to identify the source of the customers complaint.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [5, 1],
      colSpan: { "0:0": 2 },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/11/principle/car-interior.png`,
                  styles: {
                    maxHeight: "364px",
                    maxWidth: "626px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Mono",
                  icon: "cis-volume-high",
                  shape: "round",
                  theme: "secondary",
                  size: "large",
                  url: `${config.ASSETS_URL}/02/11/principle/car-interior-mono.wav`,
                },
              },
              styles: {
                justifyContent: "flex-end",
                padding: "5%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Binaural",
                  icon: "cis-volume-high",
                  shape: "round",
                  theme: "secondary",
                  size: "large",
                  url: `${config.ASSETS_URL}/02/11/principle/car-interior-binaural.wav`,
                },
              },
              styles: {
                justifyContent: "flex-start",
                padding: "5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
